(() => {
  if (customElements.get('finalfy-journey')) return;
  customElements.define('finalfy-journey', class extends HTMLElement {
    connectedCallback() {
      this.media = matchMedia('(min-width: 901px) and (prefers-reduced-motion: no-preference)');
      this.chapters = [...this.querySelectorAll('[data-journey-step]')];
      this.stage = this.querySelector('.fy-journey-stage');
      this.status = this.querySelector('[data-journey-status]');
      this.motionButton = this.querySelector('.fy-motion-toggle');
      this.reducedByUser = false;
      this.toggleMotion = () => { this.reducedByUser = !this.reducedByUser; this.configure(); };
      this.motionButton.addEventListener('click', this.toggleMotion);
      this.queue = () => { if (!this.frame && this.media.matches && !this.reducedByUser) this.frame = requestAnimationFrame(() => { this.frame = 0; this.draw(); }); };
      this.configure = () => {
        this.motionButton.hidden = !this.media.matches;
        this.motionButton.setAttribute('aria-pressed', String(this.reducedByUser));
        this.toggleAttribute('data-enhanced', this.media.matches && !this.reducedByUser);
        if (!this.media.matches || this.reducedByUser) { this.stage.removeAttribute('style'); this.chapters.forEach(chapter => chapter.style.removeProperty('--chapter-offset')); this.status.textContent = 'RECEIVE / INSPECT / PREP / SHIP'; }
        else this.queue();
      };
      this.media.addEventListener('change', this.configure);
      window.addEventListener('scroll', this.queue, { passive: true });
      window.addEventListener('resize', this.queue, { passive: true });
      this.configure();
    }
    draw() {
      if (!this.isConnected || !this.media.matches || this.reducedByUser) return;
      const middle = innerHeight * .52;
      const first = this.chapters[0].getBoundingClientRect();
      const last = this.chapters[3].getBoundingClientRect();
      const start = first.top + first.height / 2;
      const end = last.top + last.height / 2;
      const progress = Math.max(0, Math.min(1, (middle - start) / Math.max(1, end - start)));
      // Ease between intentional poses instead of continuously spinning.
      const segment = Math.min(2, Math.floor(progress * 3));
      const local = progress * 3 - segment;
      const eased = local * local * (3 - 2 * local);
      const poses = [
        { ry: -28, rx: -18, scale: .90, lift: 16 },
        { ry: 35, rx: -26, scale: 1.18, lift: -25 },
        { ry: 145, rx: -12, scale: 1.04, lift: -12 },
        { ry: 332, rx: -18, scale: .88, lift: 12 }
      ];
      const blend = key => poses[segment][key] + (poses[segment + 1][key] - poses[segment][key]) * eased;
      this.stage.style.setProperty('--ry', `${blend('ry')}deg`);
      this.stage.style.setProperty('--rx', `${blend('rx')}deg`);
      this.stage.style.setProperty('--rz', '0deg');
      this.stage.style.setProperty('--scale', blend('scale'));
      this.stage.style.setProperty('--lift', `${blend('lift')}px`);
      this.stage.style.setProperty('--shadow', `${1.3 - blend('scale') * .3}`);
      this.stage.style.setProperty('--progress', `${.06 + progress * .94}`);
      const index = Math.round(progress * 3);
      this.status.textContent = `0${index + 1} / ${this.chapters[index].dataset.journeyStep}`;
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.queue);
      window.removeEventListener('resize', this.queue);
      this.media.removeEventListener('change', this.configure);
      this.motionButton.removeEventListener('click', this.toggleMotion);
      cancelAnimationFrame(this.frame);
    }
  });
})();
